/**
 * @file userConstants.js
 * @description Constants for the User management module within the Admin section.
 *              Includes UI label strings, table column definitions, column key mappings,
 *              data field key mappings, user-facing messages, and error message strings.
 *              Also covers ACS Identity and token refresh operations.
 *
 * @module userConstants
 *
 * @exports USER_STRINGS           - UI label strings (e.g. "Add User", "Edit User", "Confirm Delete").
 * @exports USER_TABLE_COLUMNS     - Column config array for the users table.
 * @exports USER_TABLE_COLUMN_KEYS - Enum-style keys matching table column IDs.
 * @exports USER_KEYS              - Enum-style keys for user data fields.
 * @exports USER_MESSAGES          - User-facing success/empty-state messages incl. ACS & token.
 * @exports USER_ERRORS            - Error message strings for CRUD, token refresh & ACS operations.
 */
export const USER_STRINGS = {
    ADD_USER: "Add User",
    EDIT_USER: "Edit User",
    DELETE_USER: "Delete User",
    FIRST_NAME: "First Name",
    LAST_NAME: "Last Name",
    EMAIL: "Email",
    ROLE: "Role",
    SEARCH_USERS: "Search Users",
    CONFIRM_DELETE: "Are you sure you want to delete this user?",
    REFRESH_TOKEN: "Refresh Token",
    CREATE_ACS_IDENTITY: "Create ACS Identity",
};

export const USER_TABLE_COLUMNS = [
    { id: "actions", isSortable: false, label: "Actions" },
    { id: "name", isSortable: true, label: "Name" },
    { id: "rolename", isSortable: true, label: "Role" },
    { id: "acsidentity", isSortable: false, label: "ACS Identity" },
];

export const USER_TABLE_COLUMN_KEYS = {
    ACTIONS: "actions",
    NAME: "name",
    ROLE_NAME: "rolename",
    ACS_IDENTITY: "acsidentity",
};

export const USER_KEYS = {
    NAME: "name",
    FIRST_NAME: "firstname",
    LAST_NAME: "lastname",
    EMAIL_ADDRESS: "emailaddress",
    ROLE_ID: "roleid",
    ROLE_NAME: "rolename"
};

export const USER_MESSAGES = {
    NO_USERS: "No users to display",
    USER_ADDED: "User added successfully!",
    USER_UPDATED: "User updated successfully!",
    USER_DELETED: "User deleted successfully!",
    USER_TOKEN_REFRESHED: "User Token refreshed successfully!",
    USER_ACS_IDENTITY_CREATED: "ACS Identity created successfully!",
};

export const USER_ERRORS = {
    ADD_USER_ERROR: "Error adding user:",
    SAVE_USER_ERROR: "Error saving user:",
    UPDATE_USER_ERROR: "Error updating user:",
    DELETE_USER_ERROR: "Error deleting user:",
    FETCH_USERS_ERROR: "Error fetching users:",
    USER_TOKEN_REFRESH_ERROR: "Error refreshing user Token",
    USER_ACS_IDENTITY_ERROR: "Error creating ACS Identity",
};